import * as St from './DesignInformationBtn.styles';

import InfoCircle from '~/icons/info-circle-filled.svg';

type DesignInformationBtnProps = {
  className?: string;
  setIsInfoModalOpen: (isOpen: boolean) => void;
};

const DesignInformationBtn = ({
  className,
  setIsInfoModalOpen,
}: DesignInformationBtnProps) => (
  <St.InfoBtn className={className} onClick={() => setIsInfoModalOpen(true)}>
    <InfoCircle />
  </St.InfoBtn>
);

export default DesignInformationBtn;
